import Contact from './Contact';
import Route from './route';

export default {
  RenderProp: Contact,
  mainRoute: Route,
};
